/** US staging / interop funnel preview host for embedded calendar booking widgets. */
export const CALENDAR_BOOKING_WIDGET_STAGING_US_BASE_URL = 'https://funnel-preview-dot-highlevel-staging.uc.r.appspot.com'

/** AU staging / interop funnel preview host for embedded calendar booking widgets. */
export const CALENDAR_BOOKING_WIDGET_STAGING_AU_BASE_URL = 'https://funnel-preview-dot-hl-app-stg-au.ts.r.appspot.com'

/** Production calendar booking widget API host. */
export const CALENDAR_BOOKING_WIDGET_PRODUCTION_BASE_URL = 'https://api.leadconnectorhq.com'
